/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const PlusIcon = () => <FontAwesomeIcon icon={faPlus} />;

export default PlusIcon;
